import { __exportAll } from "../../_virtual/_rolldown/runtime.js";

//#region src/types/plugins/ProvideSharedPlugin.ts
var ProvideSharedPlugin_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { ProvideSharedPlugin_exports };
//# sourceMappingURL=ProvideSharedPlugin.js.map